import styled, { css } from 'styled-components'
import { Flex, H2 } from '@raysync/common/components'
import { Media } from '@raysync/common/theme'

export const BannerContainer = styled(Flex)`
  ${({ theme: { spacing } }) => css`
    position: relative;
    height: 300px;
    margin-bottom: ${spacing.large};
    z-index: 0;
    text-align: center;
    justify-content: flex-start;
    ${Media.phone`
      height: 4rem;
    `}
  `}
`
export const BannerTitle = styled(H2)`
  color: #fff;
  text-align: left;
  font-size: 48px;
  margin-top: 30px;
  span {
    margin-left: 10px;
    font-size: 18px;
  }
  ${Media.phone`
    font-size: .48rem;
    margin-top: .3rem;
    span {
     font-size: .18rem;
    }
  `}
`
export const BlogContainer = styled.div`
  position: relative;
  height: 400px;
  z-index: 0;
  text-align: center;
  color: #fff;
  margin-bottom: 30px;
  h2 {
    color: #fff;
    font-size: 36px;
    padding: 140px 0 24px;
    font-weight: bold;
  }
  p {
    max-width: 424px;
    text-align: center;
    font-size: 16px;
    line-height: 1.4;
    margin: 0 auto;
  }
  ${Media.phone`
      height: 4rem;
      h2 {
        padding: 1.4rem 0 .24rem;
      }
  `}
`
